import { colorHexes } from "@/lib/colors";

export const ColorSwatch = ({ name, size = 16, className = "" }) => {
  const hexes = colorHexes(name);
  const style =
    hexes.length >= 2 && hexes[0] !== hexes[1]
      ? { backgroundImage: `linear-gradient(135deg, ${hexes[0]} 0 50%, ${hexes[1]} 50% 100%)` }
      : { backgroundColor: hexes[0] || "#8A8F94" };
  return (
    <span
      data-testid="color-swatch"
      title={name}
      className={`inline-block shrink-0 rounded-full border border-border/70 ${className}`}
      style={{ width: size, height: size, ...style }}
    />
  );
};
